import { AspectRatio, Box, Stack, Text } from '@chakra-ui/react';
import { Routes } from '@constants/routes';
import useSSRDate from '@hooks/useSSRDate';
import Image from 'next/image';
import Link from 'next/link';
import Body1 from '../../../../typography/Body1';
import Body2 from '../../../../typography/Body2';

const Card = ({
  post: {
    coverImage: { imageUrl = '', title: imageTitle = '' },
    slug,
    title,
    subTitle,
    publishedAt,
  },
}) => {
  const { formattedDate } = useSSRDate(publishedAt);

  return (
    <Box flex="1" bg="white" boxShadow="0px 0px 12px 0px #0000001A" borderRadius={12}>
      <Box overflow="hidden" borderRadius={12}>
        <Link href={`${Routes.articles}/${encodeURIComponent(slug)}`}>
          <Stack
            borderRadius={8}
            overflow="hidden"
            cursor="pointer"
            sx={{
              ':hover': { opacity: 0.6 },
              transition: 'opacity 200ms ease-in-out',
            }}
          >
            <AspectRatio ratio={[2.2, 2.2, 2.5]}>
              <Image alt={imageTitle} src={imageUrl} width={340} height={244} />
            </AspectRatio>
            <Stack p={3} spacing={1}>
              <Body1
                sx={{
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
                lineHeight={1.3}
                bold
              >
                {title}
              </Body1>
              <Body2
                sx={{
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {subTitle}
              </Body2>
              <Text
                fontSize={16}
                fontWeight={500}
                color="gray.500"
                sx={{
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: 'vertical',
                }}
              >
                {formattedDate}
              </Text>
            </Stack>
          </Stack>
        </Link>
      </Box>
    </Box>
  );
};
export default Card;
